export const WALLET_CONNECTION_LIST_REQUEST = 'WALLET_CONNECTION_LIST_REQUEST';
